import { useTranslation } from "react-i18next";
import { useAPI } from "../../../../../lib/common";
import { usePictureSets } from "../../../../hooks/usePictureSets";
import React, { useMemo } from "react";
import { getTemplateTranslation } from "../../../../../Providers/TemplateInstanceProvider";
import i18next from "i18next";
import useTemplateList from "../../../hooks/useTemplateList";
import useGoogleFonts from "../../../../../hooks/useGoogleFonts";
import { templateFontList } from "../../../Components/EditTemplateProduct/common";
import SubHeader from "../../../Components/SubHeader";
import { Skeleton } from "@material-ui/lab";
import Box from "@material-ui/core/Box";
import SubjectSelector from "../../../Components/SubjectSelector";
import ListTemplatesPage from "./ListTemplatesPage";
import I18n from "../../../../../i18n";
export const PhotogiftWrapper = ({ type, category }) => {
  const { t, i18n } = useTranslation();
  const [categoryInfo] = useAPI(
    `/api/webshop/templates/photogift/categories/` + category + "/info",
  );
  const { currentPictureSet } = usePictureSets();
  const categoryName = useMemo(() => {
    if (!categoryInfo) {
      return "";
    }
    return getTemplateTranslation(categoryInfo.names, i18next.language);
  }, [categoryInfo]);

  const options = useMemo(() => {
    return {
      pictureSet: currentPictureSet,
      // Not really used except for getting the template list to reload
      language: i18n.language,
    };
  }, [currentPictureSet, I18n.language]);

  console.log("Template list options", options);

  const [templateList, loadingTemplates] = useTemplateList(
    type,
    category,
    options,
  );
  const { loaded: fontsLoaded } = useGoogleFonts(templateFontList);

  const canViewWithOwnPictures = categoryInfo?.userImagePreviews;

  return (
    <>
      <SubHeader
        title={categoryName || <Skeleton variant="text" />}
        subtitle={t("Choose template")}
      />
      {/*canViewWithOwnPictures && <TypeOptions type={type} disableFilters={true}/>*/}
      <Box justifyContent="center" display="flex">
        <Box sx={{ width: "80vw" }}>
          <SubjectSelector disableGutters />
        </Box>
      </Box>
      <ListTemplatesPage
        loading={loadingTemplates || !fontsLoaded}
        type={type}
        category={category}
        canViewWithOwnPictures={canViewWithOwnPictures}
        separateFromBackground={categoryInfo?.separateFromBackground}
        templates={templateList.templates}
      />
    </>
  );
};
